import axios from "axios";

const BASE_API_URL = "/api/onbase/upload";

export function getUploadTypes() {
    return axios
        .get(`${BASE_API_URL}/properties`)
        .then(result => result.data);
}

export function uploadDocument(formData) {
    return axios
        .post(`${BASE_API_URL}`, formData)
        .then(result => result.data);
}
